export default __webpack_public_path__ + "static/media/long-curl.a6ca86f5.png";